
/**
 * This function is used for the patient stub for 
 * upcoming appts 
 */

export const patientStubForUpcomingAppts = () => (
  {
    "DateOfBirth": "1937-11-25",
    "Sex": "Male",
    "Race": "White",
    "MaritalStatus": "Single",
    "EthnicGroup": "Not Hispanic, Latino/a, or Spanish origin",
    "NationalIdentifier": "xxx-xx-8823",
    "Status": "Alive",
    "PatientID": [
      {
        "ID": "E2622",
        "Type": "EPI"
      },
      {
        "ID": "E2733",
        "Type": "MRN"
      },
      {
        "ID": "     Z4502",
        "Type": "INTERNAL"
      },
      {
        "ID": "Z4502",
        "Type": "EXTERNAL"
      }
    ],
    "Name": "Grand Central,Mike",
    "FirstName": "Mike",
    "LastName": "Grand Central",
    "EmergencyContacts": [
      {
        "Name": "Adt Validate,Cindy",
        "Relation": "Friend",
        "PhoneNumbers": [
          {
            "Type": "Home Phone",
            "Number": "608-271-9000"
          }
        ]
      }
    ],
    "Addresses": [
      {
        "PostalCode": "53593",
        "State": "Wisconsin",
        "Street": [
          "1979 Milky Way"
        ],
        "Email": [
          "moin"
        ],
        "Type": "Permanent",
        "City": "VERONA",
        "Country": "United States of America",
        "PhoneNumbers": [
          {
            "Type": "Home Phone",
            "Number": "608-271-9000"
          }
        ]
      },
      {
        "Street": [
          "moin"
        ],
        "Email": [
          "moin"
        ],
        "Type": "Temporary",
        "PhoneNumbers": [
          {}
        ]
      }
    ]
  }
);

